import { render, staticRenderFns } from "./PrescriptionFilterButtons.vue?vue&type=template&id=70eb5aba&"
import script from "./PrescriptionFilterButtons.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionFilterButtons.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionFilterButtons.vue?vue&type=style&index=0&id=70eb5aba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports